import { Routes } from '@angular/router';
import { authGuard } from '@mottu-ops/sso';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full',
	},
	{
		path: 'home',
		loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
	},
	{
		path: 'ticket-classifier',
		canActivate: [authGuard],
		loadComponent: () =>
			import('./features/ticket-classifier/ticket-classifier.component').then(m => m.TicketClassifierComponent),
	},
	{
		path: 'pr-analyzer',
		canActivate: [authGuard],
		loadComponent: () => import('./features/pr-analyzer/pr-analyzer.component').then(m => m.PrAnalyzerComponent),
	},
	{
		path: 'dashboard',
		canActivate: [authGuard],
		loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
	},
	{
		path: '**',
		redirectTo: 'home',
	},
];
